<template>
  <modal id="addFineTimestampKeyForm"
         v-model="visible"
         :title="$t('gc-geolocationForm:addFineTimestampKey')"
         :callback="createKey"
  >
    <small slot="modal-header-right" class="text-muted font-italic">{{ $t('gc-geolocationForm:required') | capitalize }}</small>

    <div slot="modal-body">
      <div class="form-group">
        <label for="index" class="control-label">{{ $t('gc-geolocationForm:index') | capitalize }} *</label>
        <select id="index"
                v-model="index"
                v-validate="'required|number|between:0,3'"
                :class="{ 'is-invalid': errors.has('index') }"
                :data-vv-as="$t('gc-geolocationForm:index')"
                name="index"
                class="form-control"
        >
          <option :value="0" :disabled="isIndexAlreadyUsed(0)">0<template v-if="isIndexAlreadyUsed(0)"> ({{ $t('gc-geolocationForm:alreadyExists') }})</template></option>
          <option :value="1" :disabled="isIndexAlreadyUsed(1)">1<template v-if="isIndexAlreadyUsed(1)"> ({{ $t('gc-geolocationForm:alreadyExists') }})</template></option>
          <option :value="2" :disabled="isIndexAlreadyUsed(2)">2<template v-if="isIndexAlreadyUsed(2)"> ({{ $t('gc-geolocationForm:alreadyExists') }})</template></option>
          <option :value="3" :disabled="isIndexAlreadyUsed(3)">3<template v-if="isIndexAlreadyUsed(3)"> ({{ $t('gc-geolocationForm:alreadyExists') }})</template></option>
        </select>
        <div class="invalid-feedback">{{ errors.first('index') }}</div>
      </div>

      <div class="form-group">
        <label for="aesKey" class="control-label">{{ $t('gc-geolocationForm:aesKey') | capitalize }} *</label>
        <input id="aesKey"
               v-model="aesKey"
               v-validate="'required|hexa32'"
               :class="{ 'is-invalid': errors.has('aesKey') }"
               :data-vv-as="$t('gc-geolocationForm:aesKey')"
               type="text"
               name="aesKey"
               class="form-control"
               maxlength="32"
        >
        <div class="invalid-feedback">{{ errors.first('aesKey') }}</div>
      </div>
    </div>
  </modal>
</template>

<script>
import { find } from 'lodash-es'
import { mapGetters } from 'vuex'
import to from '@/modules/await-to-js'
import eventBus from '@/modules/eventBus'

export default {
  model: {
    prop: 'show',
    event: 'change'
  },

  props: {
    // Display or hide modal
    // To be used as v-model
    show: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      // Display or hide b-modal
      // It cannot change our props, so we need another variable
      visible: false,
      // Form
      index: '',
      aesKey: ''
    }
  },

  computed: {
    ...mapGetters(['gateway'])
  },

  watch: {
    // Synchronize show and visible
    // Use change event to update v-model
    show () {
      this.reset()
      this.visible = this.show
    },
    visible () {
      this.$emit('change', this.visible)
    }
  },

  methods: {
    async reset () {
      this.index = ''
      this.aesKey = ''

      // Reset form validation
      await this.$nextTick()
      this.$validator.reset()
    },

    isIndexAlreadyUsed (index) {
      return find(this.gateway.gatewayKeys, key => key.index === index) !== undefined
    },

    async createKey () {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      let error
      [error] = await to(this.$api.putLnsGatewayAesKey(this.gateway, this.index, { aesKey: this.aesKey }))
      if (error) return

      this.visible = false
      // Success
      eventBus.$emit('message-success', this.$t('gc-geolocationForm:createSuccess'))
      // Reset form
      this.reset()
      // Refresh list
      this.$emit('success')
    }
  }
}
</script>
